import GithubProvider from './github'
import SourceGraphProvider from './sourceGraph'

export class GitAPI
	owner
	repo
	filePath = ''
	ref
	source # "github.com" "gitlab.com" "bitbucket.com" ...

	ghProvider
	sgProvider
	uniqueId = 12 # widgets in scrim have a unique id. We start it from 12

	def constructor(props)
		owner = props.owner
		repo = props.repo
		filePath = props.filePath
		ref = props.ref
		source = props.source

		ghProvider = new GithubProvider(self)
		sgProvider = new SourceGraphProvider(self)

		getRef!
	def exec(method, ...params)
		try await sgProvider[method](...params) catch e
			# console.log "::sg er", method, params, e
			return ghProvider[method](...params) if source == 'github.com'
	def getRef
		ref = await exec('getRef', owner, repo)

	def loadFileContent({fullPath})
		exec('loadFileContent', {fullPath})

	def loadFolderContent({fullPath})
		exec('loadFolderContent', {fullPath})

	def downloadFiles(url, parentId, depth = Infinity, currentDepth = 0)
		return [] if currentDepth > depth

		const response = await global.fetch(url, {headers})
		let data = await response.json()
		const items = []
		if data.entries
			data = data.entries
		elif data.type == 'file'
			data = [data]
		if Array.isArray(data)
			for file in data
				const item =
					id: uniqueId++
					name: file.name
					type: file.type
					parent: parentId
				if file.type == 'file'
					const fileResponse = await global.fetch(file.download_url, {headers})
					const fileContents = await fileResponse.text()
					item.body = fileContents

				items.push item unless item.done?
				if file.type === "dir" and currentDepth < depth
					const subItems = await downloadFiles(file.url, item.id, depth, currentDepth + 1)
					items.push(...subItems)
		items
